import React from 'react';
import Link from '../link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const CertifiedCollision: React.FC = () => {
  const pdfs = [
    {
      name: 'Certified Collision Center Brochure',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/CertifiedCollisionCenterBrochure.pdf`,
    },
    {
      name: 'Certified Collision Center Booklet',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/CertifiedCollisionCenterBooklet.pdf`,
    },
    {
      name: 'ADAS-Bumper cover, paint repair (Vehicles with BLIS and metallic paint)',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_ADAS(2-22).pdf`,
    },
    {
      name: 'Adhesives',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_Adhesives.pdf`,
    },
    {
      name: 'Aftermarket Parts',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_Aftermarket-Parts.pdf`,
    },
    {
      name: 'Aluminum Inspection',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/aluminum-inspection-10-29-24.pdf`,
    },
    {
      name: 'Clearcoat Blending',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_Clearcoat-Blending(2-22).pdf`,
    },
    {
      name: 'Customer Parts Disclosure & Authorization Form',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Customer-Parts-Disclosure_Revised(2-22).pdf`,
    },
    {
      name: 'EV Battery Handling',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/ev-battery-handling-10-29-24.pdf`,
    },
    {
      name: 'EV Welding',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/ev-welding-10-29-24.pdf`,
    },
    {
      name: 'Full Body Sectioning',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_Full-Body-Sectioning(2-22).pdf`,
    },
    {
      name: 'Glass',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/glass-10-29-24.pdf`,
    },
    {
      name: 'Hardware',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_Hardware(2-22).pdf`,
    },
    {
      name: 'Reconditioned Parts',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_Reconditioned-Parts(2-22).pdf`,
    },
    {
      name: 'Salvage Parts',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_Salvage-Parts(2-22).pdf`,
    },
    {
      name: 'Scanning and Diagnostic',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/scanning-and-diagnostics-10-29-24.pdf`,
    },
    {
      name: 'SRS',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_SRS(2-22).pdf`,
    },
    {
      name: 'Steering Column Inspections',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/steering-column-inspections-10-29-24.pdf`,
    },
    {
      name: 'Steering Racks',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_Steering-Racks(2-22).pdf`,
    },
    {
      name: 'Tires',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_Tires(2-22).pdf`,
    },
    {
      name: 'Wheels',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Position_Wheels(2-22).pdf`,
    },
    {
      name: 'Windshields',
      url: `${process.env.CDN_URL}/wholesale-parts-hub/Volvo_Car_USA_LLC_Windshield_Position_Statement_05112026.pdf`,
    },
  ];

  return (
    <div className="wpc-content">
      <h2>
        Volvo is currently looking for some elite facilities to add to our Volvo
        Certified Collision Network.
      </h2>
      <p>
        If interested in becoming a part of the program please reach out to your
        Volvo Retailer and request sponsorship. Should you have any questions
        regarding the program please select the download link &quot;
        <Link
          href={`${process.env.CDN_URL}/wholesale-parts-hub/CertifiedCollisionCenterBooklet.pdf`}
        >
          <a>Certified Collision Center Booklet</a>
        </Link>
        &quot; and contact the Certified Collision Program for Volvo Cars US &
        Canada at{' '}
        <a href="mailto:certcoll@volvocars.com">certcoll@volvocars.com</a>.
      </p>
      <p>
        Volvo Cars US and Volvo Cars Canada latest position statements on
        vehicle repairs can be downloaded below.
      </p>
      <ul>
        {pdfs.map((pdf, index) => (
          <li key={index}>
            <Link href={pdf.url}>
              <a>
                <FontAwesomeIcon icon={faDownload} /> {pdf.name}
              </a>
            </Link>
          </li>
        ))}
      </ul>
      {/* language=CSS */}
      <style jsx>{`
        .wpc-content {
          padding: 2rem 3rem;
          font-family: 'Volvo Novum', sans-serif;
          font-size: 14px;
          min-height: 30rem;
        }

        ul {
          list-style: none;
          margin: 0;
          padding: 0;
        }

        ul li {
          display: block;
          padding-bottom: 1rem;
        }

        .wpc-content :global(a) {
          color: #333;
        }

        .wpc-content :global(a:hover) {
          color: #707070;
        }
      `}</style>
    </div>
  );
};

export default CertifiedCollision;
